import { render, staticRenderFns } from "./ExtraSubOptionsModal.vue?vue&type=template&id=b04583de&"
import script from "./ExtraSubOptionsModal.vue?vue&type=script&lang=js&"
export * from "./ExtraSubOptionsModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports